import { ProductOrderDto } from "src/dtos/productOrder/ProductOrderDto";
import { XycoordinateDto } from "src/dtos/xyCoordinate/xyCoordinateDto";
import { ItemDto } from "src/types/base";
import { getFutureWeekdayExceptTodayAndTomorrow } from "src/utils/date/dateUtils";
import { formatDate } from "src/utils/string/stringUtil";

export interface MST3050_R01Dto {
	itemHeaderDto: MST3050_R01HeaderDto;
	xyCoordinateDetailDtoList: MST3050_R01DetailDto[];
}

export interface MST3050_R01HeaderDto extends ItemDto {

	inserted: boolean,
	isModified: boolean,

    
}

/**
 * 생산 실적 관리의 단일 기본 데이터 (
 */
export const defaultMST3050_R01HeaderDto: MST3050_R01HeaderDto = {
	valueIndex: 0,
	orderIndex: 0,
	orderIndexSeq: 0,
	itemCd: '',
	itemNm: '',
	modelNo: '',
	itemSpec: '',
	itemUnit: '',
	brandCd: '',
	itemGroup: '',
	itemAccount: '',
	stockQty: 0,
	itemCost: 0,
	workCost: 0,
	stockAmount: 0,
	locationCd: '',
	locationNm: '',
	locationCd2: '',
	purQty: 0,
	packQty: 0,
	salQty: 0,
	itemImage: '',
	itemImage2: '',
	customCd: '',
	customNm: '',
	customItemcd: '',
	equipmentCd: '',
	equipmentNm: '',
	prodStockType: 'I',
	inspectYn: 'Y',
	remark: '',

	inserted: false,
	isModified: false


};

export interface MST3050_R01DetailDto extends XycoordinateDto {

	childItemNm: string;
	childItemSpec: string;
	childItemUnit: string;

	inserted: boolean,
	isModified: boolean,

}

export const defaultMST3050_R01DetailDto: MST3050_R01DetailDto = {
	valueIndex: 0,
	orderIndex: 0,
	orderIndexSeq: 0,

	prntItemcd: '',
	coordinateCd: '',
	coordinateNm: '',
	coordinateSeq: 0,
	coordinateUsage: 0,
	xcoordinate: 0,
	ycoordinate: 0,
	orient: 0,
	topBottom: '',
	childItemcd: '',
	applyBeginDt: formatDate(new Date()),
	applyEndDt: formatDate(new Date()),
	afeederCd: '',
	bfeederCd: '',
	cfeederCd: '',
	remark: '',

	childItemNm: '',
	childItemSpec: '',
	childItemUnit: '',

	inserted: false,
	isModified: false,
}
